import { render, staticRenderFns } from "./CreditDetails.vue?vue&type=template&id=680d278a"
import script from "./CreditDetails.vue?vue&type=script&lang=ts"
export * from "./CreditDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports